import React from 'react';
import { formatIsoDateToMasked } from '../../../utils/masks';
import AppInputLabel from './AppInputLabel';
import styles from './AppReadonlyField.module.css';

interface AppReadonlyFieldProps {
  id?: string;
  label?: string;
  value?: React.ReactNode;
  containerClassName?: string;
}

export const formatAppReadonlyValue = (value: unknown, inputType?: string): string => {
  if (value == null) {
    return '';
  }

  const text = String(value).trim();
  if (!text) {
    return '';
  }

  if (inputType === 'date' || /^\d{4}-\d{2}-\d{2}$/.test(text)) {
    return formatIsoDateToMasked(text) || text;
  }

  return text;
};

const AppReadonlyField: React.FC<AppReadonlyFieldProps> = ({
  id,
  label,
  value,
  containerClassName = '',
}) => {
  const content = value == null || value === '' ? '—' : value;
  const className = [styles.container, containerClassName].filter(Boolean).join(' ');

  return (
    <div className={className}>
      {label ? <AppInputLabel htmlFor={id}>{label}</AppInputLabel> : null}
      <p id={id} className={styles.value}>{content}</p>
    </div>
  );
};

export default AppReadonlyField;
